
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getOficios() {
        const url = `${API_URL}/oficios`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    getPaginated(params) {
        return axios.get(`${API_URL}/oficios/paginated`, {
            headers: authHeader(),
            params,
        });
    },
    createData(data) {
        return axios.post(`${API_URL}/oficios`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/oficios/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/oficios/${id}`, { headers: authHeader() });
    },
};